import { OrderStatusEnum } from '@modules/orders-module/enums/order-status.enum'

export const FilledOrderStatuses: OrderStatusEnum[] = [OrderStatusEnum.FILLED]
